import CoreMenuHomePage from 'src/dispensary/core-menu/home';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { getDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getDispensaryServerSideProps;

CoreMenuHomePage.layout = CoreMenuLayout;
export default CoreMenuHomePage;
